import axios from 'axios';
import commonFunction from "@/commons/commonFunction";
let BaseAPIFileStreamConfig = axios.create({
	baseURL: window._apis['Business'],
	headers: {
		// Không set Content-Type ở đây — để axios tự generate boundary khi data là FormData (breaking change axios 1.x)
		'Access-Control-Allow-Origin': '*',
		'Authorization': `Bearer ${commonFunction.getAuthToken()}`
	},
});
export default BaseAPIFileStreamConfig;